<template>
  <el-card>
    <div slot="header"><slot name="header"></slot></div>
    <pre>{{ model }}</pre>
    <el-form ref="form">
      <el-form-item label="Header">
        <el-input :value="model.header" @input="update('header', $event)"></el-input>
      </el-form-item>
      <el-form-item label="Body">
        <el-input type="textarea" :value="model.body" @input="update('body', $event)" :rows="10"></el-input>
      </el-form-item>
    </el-form>
  </el-card>
</template>
<script>
import debounce from 'lodash/debounce'
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      model: state => state.draftForm.model
    })
  },
  methods: {
    update: debounce(function (key, value) {
      this.updateProperty({ key, value })
    }, 300),
    ...mapActions('draftForm', [
      'updateProperty'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/news/Editor.vue